import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WheelChairSvg, EscalatorSvg, ParkingSvg, RouteSvg, FeederSvg, AirportSvg, PaidPorter } from '../../common/svg/AllSvg';

const StationDetails = () => {
	const [data, setData] = useState<any[]>([])
	const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
	const { t } = useTranslation('common');

	useEffect(() => {
		if (!!stationDetailData) {
			let arr: any[] = []
			for (let i = 0; i < stationDetailData?.facility?.length; i++) {
				const el = stationDetailData?.facility?.[i];
				let obj: any = { ...el }

				if (el?.class_name === "divyang-friendly") {
					obj.icon = WheelChairSvg
					arr.push(obj)
				}
				if (el?.class_name === "lift") {
					obj.icon = EscalatorSvg
					arr.push(obj)
				}
				if (el?.class_name === "parking") {
					obj.icon = ParkingSvg
					arr.push(obj)
				}

				if (el?.class_name === "interchange") {
					obj.icon = RouteSvg
					arr.push(obj)
				}

				if (el?.class_name === "feeder-bus") {
					obj.icon = FeederSvg
					arr.push(obj)
				}

				if (el?.class_name === "airport") {
					obj.icon = AirportSvg
					arr.push(obj)
				}

				if (el?.class_name === "paid-porter") {
					obj.icon = PaidPorter
					arr.push(obj)
				}
			}
			setData(arr)
		}
	}, [stationDetailData])

	return (
		<>
			{/* Station details section */}
			<div className="pt-[65px] xlx:pt-[75px] pb-[150px] xlsm:pb-[100px] md:pb-[94px] st-detail-bg bg-[#0A2540]" id="facility">
				<div className="flex gap-[30px] md:gap-[50px] msm:gap-[99px] md:items-center justify-center h-full w-full container md:flex-row flex-col">
					<div className='flex flex-col gap-[8px] xlx:gap-[15px]'>
						<h3 className="md:text-right text-white font-semibold">
							{t('passenger.station_detail.station_details')}
						</h3>
						<h5 className="md:text-right text-white font-normal max-w-[260px]">
							{t('passenger.station_detail.key_highlight')}
						</h5>
					</div>

					{data?.length > 0 && <div className='flex flex-wrap gap-x-[25px] msm:gap-x-[35px] gap-y-[20px]'>
						{Array.isArray(data) && data?.map((item: any, index: number) => (
							<div className='flex flex-col gap-[8px] xlx:gap-[15px]' key={index}>
								<div className="bg-white dark:bg-bgDarkDull rounded-[15px] xlx:w-[100px] xlx:h-[100px] w-[85px] h-[85px] flex items-center justify-center">
									<item.icon />
								</div>
								<p className="font-normal text-white max-w-[85px] xlx:max-w-[100px] text-center">{item?.name}</p>
							</div>
						))}
					</div>}
				</div>
			</div>
		</>
	);
};

export default StationDetails;